<template>
  <transition name="fade">
    <div data-grm-comp="RoomSticker"
         v-if="stickerId"
         class="transition-all pointer-events-none"
         :class="`bg-${stickerId}`"
    ></div>
  </transition>
</template>

<script>
export default {
  name: 'RoomSticker',
  props: {
    stickerId: { type: String, default: '' },
  },
}
</script>